import { useRef } from 'react';
import { useTargetListener } from '../../../shared/hooks/useTargetListener';

export const usePreventScroll = <T extends Element>() => {
  const ref = useRef<T>(null);

  useTargetListener(
    ref,
    'wheel',
    (event) => {
      event.preventDefault();
    },
    {
      throttle: false,
      passive: false,
    },
  );

  return ref;
};
